<div class="voucher-card-container">
    <div
        class="voucher-card card shadow-sm position-relative w-100"
        data-testid="voucher-card"
        [style.border-radius]="'1.75rem'"
        [style.background]="'#f8f8f8'"
        style="overflow: hidden;"
    >
        <svg
            class="position-absolute top-0 start-0 w-100 h-100"
            style="opacity: 0.15; pointer-events: none;"
            viewBox="0 0 340 213.52"
            aria-hidden="true"
            preserveAspectRatio="xMidYMid slice"
        >
            <path
                *ngFor="let y of waveLines"
                [attr.d]="wavePathData"
                [attr.transform]="'translate(0 ' + y + ')'"
                fill="none"
                stroke="rgb(134, 133, 129)"
                stroke-width="1.5"
            />
        </svg>

        <div
            class="voucher-card-body card-body vstack justify-content-between position-relative"
        >
            <div class="d-flex justify-content-between align-items-start gap-3">
                <div class="voucher-card-names vstack">
                    <div
                        class="voucher-card-name fw-semibold text-uppercase fs-5 text-primary"
                        [title]="venue.voucherDisplayName()"
                        appVenueColour
                        [primaryColour]="venue.primaryColour"
                    >
                        {{ venue.voucherDisplayName() }}
                    </div>
                    <div
                        class="voucher-card-name text-uppercase text-body"
                        [title]="voucher.displayName"
                        style="letter-spacing: 1px;"
                    >
                        {{ voucher.displayName }}
                    </div>
                </div>
                <div
                    class="voucher-card-logo"
                >
                    <img
                        *ngIf="venue.voucherLogoImageId"
                        class="rounded ms-auto"
                        [src]="environment.cdnUrl | thumbor : 'voucher-logos/' + venue.voucherLogoImageId : { width: 210, height: 150, aspectFit: true }"
                        [alt]="venue.voucherDisplayName() + ' logo'"
                        style="max-width: 100%; max-height: 70px; object-fit: contain;"
                    />
                </div>
            </div>
            <div class="d-flex justify-content-between gap-2 align-items-end">
                <div class="vstack justify-content-end">
                    <div class="text-body text-uppercase small" style="letter-spacing: 1px;">
                        Value
                    </div>
                    <div
                        class="fs-5"
                        style="font-family: monospace; letter-spacing: 0.1em;"
                    >
                        <ng-container *ngIf="sku !== null; else noPrice">
                            {{ null | currencyUnit : voucher.getAmountForSKU(sku.id) : venue.currencyCode }}
                        </ng-container>
                        <ng-template #noPrice>
                            <div
                                class="bg-light rounded"
                                [style.color]="'transparent'"
                            >
                                {{ 'N/A Price' }}
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div class="vstack justify-content-end text-end">
                    <span class="text-body text-uppercase small" style="letter-spacing: 1px;">
                        Expiry Date
                    </span>
                    <span class="fs-6" style="font-family: monospace; letter-spacing: 0.1em;">
                        <ng-container *ngIf="expiryDateFromNow !== null; else noExpiry">
                            {{ expiryDateFromNow | date:'dd/MM/yyyy' }}
                        </ng-container>
                        <ng-template #noExpiry>
                            N/A
                        </ng-template>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
